import slugify from './slugify';

/**
 * Create find url
 * @deprecated - Use /profile/:vanityUrlPath
 */
export default function profileUrl(params, clean) {
  const url = ['/profile'];

  if (clean && typeof params === 'string') {
    return params.replace(/[,'&“”‘’]/g, '').replace(/--/g, '-');
  }

  if (!params) {
    return '';
  }

  if (params.name) {
    url.push(slugify(params.name));
  }

  if (params.suburb_url) {
    url.push(slugify(params.suburb_url));
  } else if (params.suburb && params.state) {
    url.push(`${slugify(params.suburb)}-${slugify(params.state)}`);
  }

  if (params.hash) {
    url.push(params.hash);
  }

  return url.join('/');
}
